import React from "react";

/**
 * Полноцветный логотип VK (белый знак на синем скруглённом квадрате) из спрайта IconProvider.
 * Цвета зашиты в символ, поэтому иконку не нужно класть на цветную подложку.
 */
export const LogoVk = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function LogoVk(props, ref) {
	return (
		<svg ref={ref} {...props}>
			<use xlinkHref="#icon-logo_vk"></use>
		</svg>
	);
});
